import ScatterService from "./scatter.service";
import NeedsService from "../needs.service";
import CommonService from "./common.service";
import SymbolService from "../symbol.service";
import BarVerticalService from "./bar.vertical.service";
import SurveyService from "../survey.service";
import $, { type } from "jquery";

class ProfileService extends CommonService{
    /*** xAxis Functions ***/

    getXAxisForEmotionalNeeds(){
        let xAxis = this.getBaseXAxis()
        let splitLine = {
            show: false
        };             
        $.extend(true, xAxis.splitLine, splitLine);          
        $.extend(true, xAxis, this.getXAxis(1));          
        return xAxis;
    }
    getXAxisForValueDrivers(){
      let xAxis = [];
      let baseXAxis = {
        type: "value",
        gridIndex: 0,
        axisLabel: {
          show:false,
        },
        axisTick: {
          show:false,
        },
        splitLine: {
          show:false,
        },
        axisLine: {
          show:false,
        },
        min: 0,
        max: 11
      };  
      
      let rightAxis = JSON.parse(JSON.stringify(baseXAxis));
      rightAxis.gridIndex = 1;
      let leftAxis = {
        interval: 5.5,
        splitArea:{
          show: true,
          areaStyle: {
            color: ["#F8F8F8","#EBEBEB"],
            opacity: 0.4,
          }
        },
      }
      $.extend(true, leftAxis, baseXAxis); 
      leftAxis.gridIndex = 0;
/*    
    leftAxis.axisLabel.show = true;  
      leftAxis.splitNumber =  10;
*/      
      xAxis.push(leftAxis);    
      xAxis.push(rightAxis);
      return xAxis;
    }
    /*** yAxis Functions ***/
       getYAxis(maxPricePower = 5,maxYAxis = 3,displayPricingPower = true,showLabelForGrid1 = true,pricingPowerAxisColor="#000"){
        let yAxis = [];
        let yAxisForNeed = this.getYAxisForNeed();
        let yYAxisForPricingPower = this.getYAxisForPricingPower(maxPricePower,showLabelForGrid1,pricingPowerAxisColor);
        yAxis.push(yAxisForNeed);
        if (displayPricingPower == true){
          yAxis.push(yYAxisForPricingPower);
        }
        if (maxYAxis == 2){
          let gridIndex = {
              gridIndex: 1,
          }
          let yAxisForEmotionalNeed = JSON.parse(JSON.stringify(yAxisForNeed));
          let yYAxisForPricingPowerForEmotionalNeed = JSON.parse(JSON.stringify(yYAxisForPricingPower));
          yYAxisForPricingPowerForEmotionalNeed.axisLabel.show = true;
          let yYAxisForPricingPowerEmotionalNeed = JSON.parse(JSON.stringify(yYAxisForPricingPowerForEmotionalNeed));
          // Add for emotional Needs
          $.extend(true, yAxisForEmotionalNeed, gridIndex);
          $.extend(true, yAxisForEmotionalNeed.axisLabel,{show:false});
          $.extend(true, yYAxisForPricingPowerEmotionalNeed, gridIndex);
          $.extend(true, yYAxisForPricingPowerEmotionalNeed.axisLabel,{show:true,color:pricingPowerAxisColor});
          let copyyAxisForEmotionalNeed = JSON.parse(JSON.stringify(yAxisForEmotionalNeed));
          let splitArea = {
            interval: 4.5,
            splitArea: {
              show: true,
              areaStyle: {
                color: ["#F8F8F8","#EBEBEB"],
                opacity: 0.4
              }
            }      
          };
            if (displayPricingPower == false){          
            let axisLabel = {
              axisLabel:{
                show: false
              }
            };
           $.extend(true, splitArea, axisLabel);
           $.extend(true, yAxisForEmotionalNeed, splitArea);
          }
          yAxis.push(yAxisForEmotionalNeed);
          if (displayPricingPower == true){
            splitArea.interval = maxPricePower / 2;
            $.extend(true, yYAxisForPricingPowerEmotionalNeed, splitArea);
            yAxis.push(yYAxisForPricingPowerEmotionalNeed);
          } else {
            yAxis.push(copyyAxisForEmotionalNeed);
          }
        }
        return yAxis;
    }    
    getYAxisForValueDrivers(emotionalNames){
      let axisLabel = {
        color: "#787878",
        fontSize: 10,
        fontFamily: "Franklin Gothic Demi Cond",
        //fontWeight: "bold",
        inside: true
      };
      let axisLabelForValueDriver = {
        color: "#000",
        fontSize: 12,
        fontFamily: "Franklin Gothic Demi Cond",
        //fontWeight: "bold",
        inside: true
      };      
      let splitLine = {
        show: true,
        lineStyle: {
          color: this.getBaseLineColor(),
          width: this.getBaseLineWidth()
        }
      };
      let axisTick = {
        "show": false
      }
      let axisLine = {
        show:false,
      };
      return [{
        type: "category",
        gridIndex: 0,
        data: emotionalNames[0],
        axisLabel: axisLabel,
        splitLine: splitLine,
        axisTick: axisTick,
        axisLine: axisLine
      },
      {
        type: "category",
        gridIndex: 0,
        data: emotionalNames[1],
        axisLabel: axisLabel,        
        splitLine: splitLine,
        axisTick: axisTick,
        axisLine: axisLine
      },
      {
        type: "category",
        gridIndex: 1,
        data: emotionalNames[2],
        axisLabel: axisLabelForValueDriver,        
        splitLine: splitLine,
        axisTick: axisTick,
        axisLine: axisLine
      }];
    }
    /***  Series Functions ***/
    getSeries(name,gridIndex,xAxisIndex,yAxisIndex,config = {},containerId = ""){
        let baseSeries = {
            name: name,
            type: 'scatter',
            gridIndex: gridIndex,
            xAxisIndex: xAxisIndex,
            yAxisIndex: yAxisIndex,
            data: [],
            emphasis: {
              disabled: true,
            },
            animation: false,
        };       
        $.extend(true, baseSeries, config);
        return baseSeries;
    }
    getPricingPowerSeries(gridIndex,xAxisIndex,yAxisIndex,itemColor = "rgb(215, 228, 189)"){
      return this.getMetricSeries(SurveyService.getWTPLabel(),gridIndex,xAxisIndex,yAxisIndex,itemColor);
    }
    getLiftSeries(name,gridIndex,xAxisIndex,yAxisIndex,itemColor,liftList,needType,emotionalNeedNamesMap = []){
      const liftColors = {
        "Reposition": "#2F5EB3",
        "In-Demand": "#D98E2C",
        "Table Stake": "#A6A6A6"
      };
      let series = this.getSeries(name,gridIndex,xAxisIndex,yAxisIndex,{
        color: liftColors[name] || itemColor,
        symbol: "roundRect",
      });
      let coordinateY = 1.45;
      let markPointData = [];
      let filteredLiftList = Array.isArray(liftList) ? liftList.filter(lift => lift.needType === needType) : [];

      filteredLiftList.forEach(lift => {
        const reposition = Number(lift.reposition);
        const inDemand = Number(lift.inDemand);
        if (!Number.isFinite(reposition) || !Number.isFinite(inDemand)) {
          return;
        }
        const liftSeriesName = reposition <= 0 && inDemand <= 0
          ? "Table Stake"
          : inDemand >= reposition ? "In-Demand" : "Reposition";
        if (name !== liftSeriesName) {
          return;
        }
        let needName = lift.needName;
        if (needType === "emotional") {
          let emotionalNeed = emotionalNeedNamesMap.find(item => item.needName === needName);
          if (typeof emotionalNeed === "undefined") {
            emotionalNeed = emotionalNeedNamesMap.find(item => Number(item.needNumber) === Number(lift.sequenceNumber));
          }
          if (typeof emotionalNeed === "undefined" || !emotionalNeed.dimensionName) {
            return;
          }
          needName = emotionalNeed.dimensionName;
        }
        // Excel equivalent:
        // IF(color="Gray", tableStakes, IF(color="Gold", harvest, differentiator))
        const liftValue = Number(liftSeriesName === "Table Stake"
          ? lift.tableStakes
          : liftSeriesName === "In-Demand" ? lift.harvest : lift.differentiator);
        markPointData.push({
          coord: [needName, coordinateY],
          value: liftValue,
          symbolSize: 0.1,
          label: {
            backgroundColor: liftColors[liftSeriesName],
            borderRadius: 2,
            formatter: function(param) {
              let value = Number(param.value);
              return Number.isFinite(value) ? value.toFixed(1) : "--";
            }
          }
        });
      });

      series.markPoint = {
        silent: true,
        symbol: "roundRect",
        symbolSize: 0.1,
        data: markPointData,
        label: {
          show: true,
          position: "inside",
          color: "#FFFFFF",
          borderRadius: 2,
          fontSize: 9,
          fontFamily: "Franklin Gothic Medium Cond",
          width: 24,
          height: 14,
          align: "center",
          verticalAlign: "middle",
          padding: 2,
          formatter: function(param) {
            let value = Number(param.value);
            return Number.isFinite(value) ? value.toFixed(1) : "--";
          }
        }
      };
      return series;
    }
    /*** Header Functions ***/
    getValueDriverHeaderSeries(gridIndex = 0, xAxisIndex = 0, yAxisIndex = 0){
      let defaultRich = {
          a: {
            align: "left",
            fontSize: 11,
            fontFamily: "Franklin Gothic Demi Cond",
           // fontWeight: "bold",
            lineHeight: 30,
            color: "#fff",
          }
      };
      let base =  {
        name: "Header",
        type: "scatter",
        label: {
          show: false,
        },
        xAxisIndex: 0,
        yAxisIndex: 0,
        gridIndex: 1,
      }
      let valueDriverSeries = {
        markArea: {
          label: {
            backgroundColor: "#2F5EB3",
            padding: [0,5,5,5],
            height: 24,
            distance: 0
          },
          data: [
            [
              {
                name: "Value Driver",
                itemStyle: {
                  color: "none"
                },
                label: {
                  width: 205,
                  rich: defaultRich,
                  formatter: "{a|Value Driver}",
                  offset: [-111, 0]
                  
                }
              },
              {
                "xAxis": "0"
              }
            ],
          ]
        }
      };
      let emotionalNeedRich = JSON.parse(JSON.stringify(defaultRich));
      emotionalNeedRich.a.align = "center";
      $.extend(true, defaultRich, emotionalNeedRich);      
      let emotionalNeedSeries = {
        markArea: {
          label: {
            backgroundColor: "#2F5EB3",
            padding: [0,0,5,5],
            height: 24,
            distance: 0
          },
          data: [
            [
              {
                name: "Emotional Need",
                itemStyle: {
                  color: "none"
                },
                label: {
                  width: 457,
                  //offset: [9,0],
                  padding: [0,0,5,35],
                  rich: emotionalNeedRich,
                  formatter: "{a|Emotional Need}",
                  "xAxis": "1"
                }
              },
              {
                "xAxis": "10"
              }
            ],
          ]
        }

      };
      $.extend(true, valueDriverSeries, base);
      $.extend(true, emotionalNeedSeries, base);
      $.extend(true, emotionalNeedSeries, BarVerticalService.getMarkLine(true,5.5));
      emotionalNeedSeries.markLine.lineStyle.color = "#C0C0C0";
      let returnSeries = [];
      returnSeries.push(valueDriverSeries);
      returnSeries.push(emotionalNeedSeries);
      return returnSeries;
    }
    getBaseNeedsHeaderSeries(names = [], breakPointList = [], numberOfNeeds = 14, gridIndex = 0, xAxisIndex = 1, yAxisIndex = 0, defaultWidth = 0,includeMarkLine = false){
      let finalData = [];
      let base =  {           
        name: '',
        itemStyle: {  
          color: '',
        },
        label: {
          width: defaultWidth,
          overflow: 'overflow',
          ellipsis: '...',                    
          rich: {
            a : {
              align: 'center',
              fontSize: 12,
              fontFamily: "Franklin Gothic Medium Cond",                    
           //   fontWeight: "bold",
              lineHeight: 35,
              color: '#fff',
              verticalAlign: 'middle',
            }
          }
        }
      };
      let colorList = [];
      for (let i = 0; i < names.length; i++) {
        colorList.push('none')
      }
      let startList = [''];
      let endList = [];
      startList.push(...breakPointList.map(x => String(x+2)));
      endList = breakPointList.map(x => String(x + 1));
      endList.push(String(numberOfNeeds));
      for (let i = 0; i < names.length; i++) {
        let newCoord = JSON.parse(JSON.stringify(base));
        let xCood = []
        // 1st Coord
        $.extend(true, newCoord.itemStyle, {color: colorList[i]});
        $.extend(true, newCoord, {name: names[i]});
        $.extend(true, newCoord.label, {formatter: '{a|'+names[i]+'}'});
        xCood.push(newCoord);
        if (i > 0) {
          newCoord.xAxis = startList[i]
        } 
        // 2nd Coord
        xCood.push({xAxis: endList[i]});
        finalData.push(xCood);

      }
      let series = {
        name: "Header",
        type: "scatter",
        label: {
          "show": false,
        },
        xAxisIndex: xAxisIndex,
        yAxisIndex: yAxisIndex,
        gridIndex: gridIndex,
        markArea: {
          label: {
            backgroundColor: '#2F5EB3',
            color: 'white',
            padding: [0,0,10,0],
            fontSize: 8,
            fontWeight: 'bold',
            height: 24,
            distance: 1,
          },
          data: finalData
        },
      };
      if (includeMarkLine) {
        series.markLine = this.getDefaultMarkLineForEmotionalNeeds();
      }
      return series;
    }    
    getWinnersHeader(breakPointList,numberOfNeeds = 12,displayType = 'winner'){
      let header = this.getBaseNeedsHeader(breakPointList,numberOfNeeds,displayType);
      let returnHeader = {
        gridIndex: 0,
        
        position: "top",
        axisTick: {
            show: false,
        },
        axisLabel: {
            margin:5,
            height:20,
            fontSize: 12,
            fontFamily: "Franklin Gothic Demi Cond",
            fontWeight: 'bold',
            color: "#FFF",
            backgroundColor: "#2f5eb3",
            width: 30,
        },
        data: [""]
      }
      $.extend(true, header, returnHeader);
      return header;      
    }
    getFunctionalNeedsHeader(breakPointList, numberOfNeeds = 12,displayType = 'need'){
        let header = this.getBaseNeedsHeader(breakPointList,numberOfNeeds,displayType);
        let functionalNeedHeader = {
            gridIndex: 0,
            data: [""],
        }
        $.extend(true, header, functionalNeedHeader);
        return header;
    }
    getRelativeStrengthDisplay(property,isPositiveCorrelation){
        if (!isNaN(property)){
            let value = Number(property).toFixed(2)
            let valueToDisplay = "<span style='";
            if (isPositiveCorrelation == true){
              if (value >= 0.8 && value <= 1.0) {
                valueToDisplay += "color: #548235";
              } else if (value >= 0.5 && value < 0.8) {
                valueToDisplay += "color: #70AD47";
              } else if (value >= 0.3 && value < 0.5) {
                valueToDisplay += "color: #A9D18E";
              } else {
                valueToDisplay += "color: #000000";
              }
            } else {
              if (value <= -0.8 && value >= -1.0) {
                valueToDisplay += "color: #548235";
              } else if (value <= -0.5 && value > -0.8) {
                valueToDisplay += "color: #70AD47";
              } else if (value <= -0.3 && value > -0.5) {
                valueToDisplay += "color: #A9D18E";
              } else {
                valueToDisplay += "color: #000000";
              }
            }
            valueToDisplay += "'>";
            valueToDisplay += "r="+value;
            valueToDisplay += "</span>";
            return valueToDisplay;
        } 
        return property;
    }
    getRelativeStrengthName(name){
      if (name.includes("Mild")){
        return "";
      } else if (name.includes("Strong+")){
        return "Strong+";
      } else if (name.includes("Strong")){
        return "Strong";
      }
    }
    getMarkPointDataForRelativeStrength(name,value,isEmotionalNeed,containerId,emotionalNeedNamesMapEntry = null){
      if (isEmotionalNeed){
        if (containerId ===  "value_emotional_needs_chart" && emotionalNeedNamesMapEntry != null){
          let emotionalName = emotionalNeedNamesMapEntry.needName.split(","  );
          name = emotionalName[1].trim();
          return { coord: [2.7, name], value: value };
        }
      }
      return { coord: [name, 2.7], value: value };
    }
    getRelativeStrengthConfig(legend){
      let markPoint = {
              symbol: 'pin',
              symbolSize: 28,
              color: legend.symbolColor,
              data: [],
              symbolOffset: [0, 10],
              label: {
                show: true,
                color: '#fff',     // Text color inside pin
                fontSize: 9,
                fontFamily: "Franklin Gothic Medium Cond",
                formatter: function (param) {
                  return Number(param.value).toFixed(3);
                }
              }
        };
      return {
          markPoint: markPoint,
          symbol: 'pin',
          color: legend.symbolColor,
      };
    }
    getTopAttributeRecommendationsSeries(isMatchChart,gridIndex,xAxisIndex,yAxisIndex,needType, topAttributeRecommendation,legendName,isHorizontal = false){
      // loop through topAttributeRecommendation and create an array based on the needType
      let finalData = [];
      for (let i = 0; i < topAttributeRecommendation.length; i++) {
        let data = topAttributeRecommendation[i];
        let isEmotional = NeedsService.isEmotionalNeedByDimensionName(data);
        if (needType === "emotional" && isEmotional == true) {
            finalData.push(data);
        } else if (needType === "functional" && isEmotional == false) {
            finalData.push(data);
        } 
      }
      let topAttributeRecommendationsSeriesArray = [];
      let topAttributeRecommendationSeries = this.getSeries(legendName,gridIndex,xAxisIndex,yAxisIndex,{});
      let topAttributeRecommendationsConfig = this.getTopAttributeRecommendationsConfig(isMatchChart, finalData);
      topAttributeRecommendationSeries = $.extend(true, topAttributeRecommendationSeries, topAttributeRecommendationsConfig);
      topAttributeRecommendationsSeriesArray.push(topAttributeRecommendationSeries);
      return topAttributeRecommendationsSeriesArray;
    }
    getTopAttributeRecommendationsConfig(isMatchChart,name,isNegative = false,isHorizontal = false){
      //let symbol = 'image://'+window.location.origin + '/img/chart-headers/wratings-logo-bw-300.svg'
   let symbol = 'image://'+window.location.origin + '/img/chart-headers/w-logo-solid.svg';
   
      let coordinateY = 2.4;
      let symbolOffset = isHorizontal ? [10, 0] : [0, 10];          
      let markPointData=[];
      for (let i = 0; i < name.length; i++) {
        let funcItem = name[i];
        let coord = [];
        if (isHorizontal){
          coord.push(coordinateY);
          coord.push(funcItem);

        } else {
          coord.push(funcItem);
          coord.push(coordinateY);
        }
        markPointData.push({ coord: coord });
      }
      let markPoint = {
              symbol: symbol,
              symbolSize: 20,
              color: '#fff',
              data: markPointData,
              symbolOffset: symbolOffset,
              label: {
                show: false,
              }
        };
      return {
          markPoint: markPoint,
          symbol: symbol,
          color: '#fff',
      };
    }    
    getVerbatimSeries(gridIndex,xAxisIndex,yAxisIndex,needType,verbatimsData,isHorizontal = false){
      let verbatimSeriesArray = [];
      let names = ["Negative Verbatims", "Positive Verbatims"];
      for (let i = 0; i < names.length; i++) {
        let isNegative = names[i] === "Negative Verbatims" ? true : false;
        let needData = verbatimsData.find(x => x.name === names[i] && x.needType === needType);
        if (typeof needData != "undefined"){
            let needs = needData.needs;
            let verbatimSeries = this.getSeries(names[i],gridIndex,xAxisIndex,yAxisIndex,{});
            let verbatimConfig = this.getVerbatimConfig(needs,isNegative,isHorizontal);
            verbatimSeries = $.extend(true, verbatimSeries, verbatimConfig);
            verbatimSeriesArray.push(verbatimSeries);
        }
      }
      return verbatimSeriesArray;
    } 

    getVerbatimConfig(functionalList,isNegative = false,isHorizontal = false){
      let symbol = isNegative ? 'image://'+window.location.origin + '/img/chart-headers/flag2.svg' : 
                      'image://'+window.location.origin + '/img/chart-headers/star.svg';
      //let coordinateY = isNegative ? 3.5 : 2.5;      
      let coordinateY = 2.0;
      let symbolOffset = isHorizontal ? [10, 0] : [0, 10];          
      let markPointData=[];
      for (let i = 0; i < functionalList.length; i++) {
        let funcItem = functionalList[i];
        let coord = [];
        if (isHorizontal){
          coord.push(coordinateY);
          coord.push(funcItem);

        } else {
          coord.push(funcItem);
          coord.push(coordinateY);
        }
        markPointData.push({ coord: coord });
      }
      let markPoint = {
              symbol: symbol,
              symbolSize: 20,
              color: '#fff',
              data: markPointData,
              symbolOffset: symbolOffset,
              label: {
                show: false,
              }
        };
      return {
          markPoint: markPoint,
          symbol: symbol,
          color: '#fff',
      };
    }    
    getExpectationsConfig(containerId){
      let defaultSymbolType = SymbolService.getBarSymbol();
      let symbol = {
          symbol: defaultSymbolType,
          symbolSize : [21, 4],
          zLevel: 10,
          z:10
      };
      if (containerId == "value_emotional_needs_chart" || containerId == "profile_match_by_value_emotional_chart") {
        symbol.symbolSize = [4,21];
      }
      return symbol;
    }
    getCompetitorConfig(symbol = "circle",symbolSize = 10){
        return {
            symbol: symbol,
            symbolSize: symbolSize,
        };
    }
    getEmotionalNeedsHeader(breakPointlist, numberOfNeeds = 5,displayType = 'need', headerGroups = []){
        let header = this.getBaseNeedsHeader(breakPointlist,numberOfNeeds,displayType );
        $.extend(true, header.axisLabel, {interval: 0});
        let emotionalNeedHeader = {
          gridIndex: 1,
          splitLine: {
            show: false,
          }
        }
        $.extend(true, header, emotionalNeedHeader);
        return header;
    }
    setEmotionalNeedsHeaderOrder(headerData, emotionalNeedsNameOrder){
      let newHeaderData = [];
      for (let i = 0; i < emotionalNeedsNameOrder.length; i++) {
        let emotionalNeedName = emotionalNeedsNameOrder[i];
        if (emotionalNeedName == "Assurance") {
          newHeaderData.push("Assurance");
        } else if (emotionalNeedName == "Creativity") {
          newHeaderData.push("Creativity ");
        } else if (emotionalNeedName == "Adaptability") {
          newHeaderData.push("Adaptability");
        } else if (emotionalNeedName == "Trust") {
          newHeaderData.push("Trust");
        } else if (emotionalNeedName == "Activity") {
          newHeaderData.push("Activity");
        }          
      }
      return newHeaderData;
    }
    //Parse Data
    parseDriverListData(inputData, outputData){
      if (typeof inputData !== 'undefined' && inputData !== null) {
        if (typeof inputData.otherData !== 'undefined' && inputData.otherData !== null) {
          let otherData = inputData.otherData;
          outputData.driverList = [];
          if (typeof otherData.driverList !== 'undefined' && otherData.driverList !== null){
            outputData.driverList = JSON.parse(JSON.stringify(otherData.driverList));
          }
        }
      }
      return outputData;
    }
    
    /* Profile Specific Functions*/
    getFinalDimensionTopLabels(listOfDimensionsThatNeedLabelsFlipped = []){
      let defaultDimensionTopLabelFirst = ["Trust","Assurance","Activity","Creativity","Adaptability"];
      let defaultDimensionTopLabelSecond = [];
      let finalDimensionTopLabelFirst = [];
      let finalDimensionTopLabelSecond = [];
      let flippedDimensions = Array.isArray(listOfDimensionsThatNeedLabelsFlipped) ? listOfDimensionsThatNeedLabelsFlipped : [];

      for (let i = 0; i < defaultDimensionTopLabelFirst.length; i++) {
        let dimensionName = defaultDimensionTopLabelFirst[i];
        if (flippedDimensions.includes(dimensionName)) {
          finalDimensionTopLabelSecond.push(dimensionName);
        } else {
          finalDimensionTopLabelFirst.push(dimensionName);
        }
      }

      for (let i = 0; i < defaultDimensionTopLabelSecond.length; i++) {
        let dimensionName = defaultDimensionTopLabelSecond[i];
        if (flippedDimensions.includes(dimensionName)) {
          finalDimensionTopLabelFirst.push(dimensionName);
        } else {
          finalDimensionTopLabelSecond.push(dimensionName);
        }
      }

      return {
        finalDimensionTopLabelFirst: finalDimensionTopLabelFirst,
        finalDimensionTopLabelSecond: finalDimensionTopLabelSecond,
      };
    }
    getMarkPointForEmotionalNeeds(includeBreakPoint = false,emotionalNeedNamesMap,dimensionTopLabelFirst,dimensionTopLabelSecond){
      //console.log("Emotional Needs Name Order",emotionalNeedsNameOrder);
      let bottomEven = 1.2;
      let bottomOdd = 1.2;
      let topEven = 9.8;
      let topOdd = 9.8;
      let dimensionOrder = ["Assurance","Activity","Trust","Creativity","Adaptability"];
      let data = [];
      for (let i = 0; i < dimensionOrder.length; i++) {
        let dimensionName = dimensionOrder[i];
        let isEven = i % 2 == 1;
        let topY = isEven ? topEven : topOdd;
        let bottomY = isEven ? bottomEven : bottomOdd;
        let topLabel = "";
        let bottomLabel = "";
        let dimensionMap = Array.isArray(emotionalNeedNamesMap) ? emotionalNeedNamesMap.find(item => item.dimensionName === dimensionName) : null;
        if (dimensionMap != null && typeof dimensionMap.needName == "string" && dimensionMap.needName.includes(",")) {
          let splitNames = dimensionMap.needName.split(",");
          if (splitNames.length >= 2) {
            if (dimensionTopLabelSecond.includes(dimensionMap.dimensionName)){
              topLabel = splitNames[1].trim();
              bottomLabel = splitNames[0].trim(); 
            } else if (dimensionTopLabelFirst.includes(dimensionMap.dimensionName)){
              topLabel = splitNames[0].trim();
              bottomLabel = splitNames[1].trim();
            }
          }
        }
        data.push({coord: [dimensionName, topY], value: topLabel});
        data.push({coord: [dimensionName, bottomY], value: bottomLabel});
      }
      let finalEmotionalNeedNames = [];
      for (let i = 0; i < dimensionOrder.length; i++) {
        let dimensionName = dimensionOrder[i];
        // Check if the dimensionName is in the emotionalNeedNamesList
        let dimensionMap = Array.isArray(emotionalNeedNamesMap) ? emotionalNeedNamesMap.find(item => item.dimensionName === dimensionName) : null;
        if (dimensionMap != null && typeof dimensionMap.needName == "string" && dimensionMap.needName.includes(",")){
          let splitNames = dimensionMap.needName.split(",");
          if (splitNames.length >= 2) {
            if (dimensionTopLabelSecond.includes(dimensionMap.dimensionName)){
              finalEmotionalNeedNames.push(splitNames[1].trim());
              finalEmotionalNeedNames.push(splitNames[0].trim());
            } else if (dimensionTopLabelFirst.includes(dimensionMap.dimensionName)){
              finalEmotionalNeedNames.push(splitNames[0].trim());
              finalEmotionalNeedNames.push(splitNames[1].trim());
            }            
          }
        }
      }
      if (finalEmotionalNeedNames.length >= 10){  
        data = [
          {coord: ['Assurance',topOdd], value: finalEmotionalNeedNames[0]},
          {coord: ['Assurance',bottomOdd], value: finalEmotionalNeedNames[1]},
          {coord: ['Activity',topEven], value: finalEmotionalNeedNames[2]},
          {coord: ['Activity',bottomEven], value: finalEmotionalNeedNames[3]},
          {coord: ['Trust',topOdd], value: finalEmotionalNeedNames[4]},
          {coord: ['Trust',bottomOdd], value: finalEmotionalNeedNames[5]},          
          {coord: ['Creativity',topEven], value: finalEmotionalNeedNames[6]},
          {coord: ['Creativity',bottomEven], value: finalEmotionalNeedNames[7]},
          {coord: ['Adaptability',topOdd], value: finalEmotionalNeedNames[8]},
          {coord: ['Adaptability',bottomOdd], value: finalEmotionalNeedNames[9]},          
        ];
      } 
      if (includeBreakPoint == true){
        data.push({coord: ['Assurance',5.5], value: '_______', symbolSize: .001});
        data.push({coord: ['Activity',5.5], value: '_______', symbolSize: .001});
        data.push({coord: ['Trust',5.5], value: '_______', symbolSize: .001});
        data.push({coord: ['Creativity',5.5], value: '_______', symbolSize: .001});
        data.push({coord: ['Adaptability',5.5], value: '_______', symbolSize: .001});
      }
      return {
          markPoint: {
            symbolSize: 1,
            label:{
              fontSize: 8,
              fontFamily: "Franklin Gothic Medium Cond",
              color: "#787878",
            },
            data: data,
          }
      }
    }
    buildLegendData(legend, displayNumberOfRespondents,verbatimsData,topAttributeRecommendations,topAttributeRecommendationsLegendName = "Roadmap Suggestions"){
      let legendData = [];
      let baseLegendData = [];
      if (displayNumberOfRespondents && typeof legend.respondents != "undefined"){
        baseLegendData.push(...legend.respondents);
      } else {
        baseLegendData.push(...legend.normal);
      }
      const inDemandIndex = baseLegendData.findIndex(entry => entry.elementId === "in-demand");
      const repositionIndex = baseLegendData.findIndex(entry => entry.elementId === "reposition");
      if (inDemandIndex > repositionIndex && repositionIndex >= 0) {
        const inDemandLegend = baseLegendData.splice(inDemandIndex, 1)[0];
        baseLegendData.splice(repositionIndex, 0, inDemandLegend);
      }
      let baseBarConfiguration = {     
        itemStyle: {
          borderColor: "white",
          borderWidth: 6.5,
        }        
      };
      for (let i = 0; i < baseLegendData.length; i++) {
        let legendEntry = {
          name: baseLegendData[i].elementId === "reposition"
            ? "Reposition"
            : baseLegendData[i].elementId === "in-demand" ? "In-Demand" : baseLegendData[i].name,
        };
        if (baseLegendData[i].elementId === "reposition" || baseLegendData[i].elementId === "in-demand") {
          legendEntry.icon = "roundRect";
        }
        if (typeof baseLegendData[i].elementId != "undefined" && baseLegendData[i].elementId.includes("bar") ) {
          $.extend(true, legendEntry, baseBarConfiguration);
        }
        legendData.push(legendEntry);
      }
      const hasLiftLegend = baseLegendData.some(legendEntry =>
        legendEntry.elementId === "reposition" || legendEntry.elementId === "in-demand"
      );
      if (hasLiftLegend) {
        legendData.push({ name: "Table Stake", icon: "roundRect" });
      }
      if (typeof verbatimsData != "undefined" && verbatimsData != null && verbatimsData.length > 0){
        let hasPositiveVerbatims = verbatimsData.some(x => x.name === "Positive Verbatims" && x.needs.length > 0);
        let hasNegativeVerbatims = verbatimsData.some(x => x.name === "Negative Verbatims" && x.needs.length > 0);
        if (hasPositiveVerbatims){
          legendData.push({name: "Positive Verbatims"});
        }
        if (hasNegativeVerbatims){
          legendData.push({name: "Negative Verbatims"});
        }
      }
      if (typeof topAttributeRecommendations != "undefined" && topAttributeRecommendations != null && topAttributeRecommendations.length > 0){
          legendData.push({name: topAttributeRecommendationsLegendName});
      }
      return legendData;
    }
    getDefaultLegendProfileChart(){
        let legendTextStyle = { 
            color: "#000",
        };

        $.extend(true, legendTextStyle, ScatterService.getDefaultLegendTextStyle());
        return {
            show: ScatterService.getShowLegend(),
            textStyle: legendTextStyle,              
            borderColor: '#BFBFBF',
            width:"100%",
            orient: 'vertical',
            itemWidth: 15,
            left: 795,
            top:10, 
            borderWidth: 0,
            formatter: name => name.replace("Strong+", "Strong+"),
        }
    }   
    getGridForProfileByNeedChart(includeBackgroud = true) {
        let grid1 = {
          left:110,
          top:this.getBaseGridTop(),
          width: 450,
          containLabel: false,
          bottom: 86
        };
        let grid2 = {
          top:this.getBaseGridTop(),
          left: 565,
          width: 200,
          containLabel: false,
          bottom: 86        
        };
        if (includeBackgroud == true){
            $.extend(true, grid1, ScatterService.getGridBackground());
            $.extend(true, grid2, ScatterService.getGridBackground());
        }
        let baseGrid = [];
        baseGrid.push(grid1);
        baseGrid.push(grid2);

        return baseGrid;
    }    

  getGridForValueDriverChart(includeBackgroud = true) {
    let grid1 = {
        top:this.getBaseGridTop(),
         left: 325,
         width: 450,
         containLabel: true,
         backgroundColor: this.getBaseGridBackgroundColor(),
         show: true         
     };
     let grid2 = {
        top:this.getBaseGridTop(),
         width: 220,
         left: 107,
         containLabel: true,
         backgroundColor: "#fff",
         show: true         
     };
    let baseGrid = [];
    baseGrid.push(grid1);
    baseGrid.push(grid2);

    return baseGrid;
}    
/*Tooltip Functions */
toolTipForProfileAreaChart = (params) => {
  let returnValue = "";
  for (let i = 0; i < params.length; ++i) {
      let axisValue = params[i].axisValue
      let valueToDisplay = params[i].value;
      if (i == 0){
        returnValue += "<span style='text-align:center;font-weight:bold'>" 
        returnValue += axisValue;
        returnValue += "</span><br/>";
      }
      let seriesName = params[i].seriesName;
      //returnValue += params[i].marker += " ";
      returnValue += params[i].seriesName += " : ";
      returnValue += "<span style='text-align:right'>" 
      if (seriesName == "Relative Strength"){
          returnValue += "<b>";
          returnValue += valueToDisplay;
          returnValue += "</b>"
      } else if (seriesName == "Growth Ideas" || seriesName == "Roadmap Initiatives" || seriesName == "Metric"){
          returnValue += "<b>"
          returnValue += valueToDisplay;
          returnValue += "</b>"
      } else if (valueToDisplay > 0){
        returnValue += "<b>"
        if (SurveyService.getWTPLabel() == seriesName) {
          returnValue += valueToDisplay;
          returnValue += "%";
          returnValue += "</b>";
        } else {
          returnValue += Number(valueToDisplay).toFixed(2);
          returnValue += "</b>";
        }
      } else {
          returnValue += "--";
          returnValue += "</b>";
      }
      returnValue += "</span>";
      returnValue += "<br>";
  }
  return returnValue;
}       
setDimensionNameForProfileChartByNeedNumber(number){
  if (number == 1){
    return "Trust";
  } else if (number == 2){
    return "Adaptability";
  } else if (number == 3){
    return "Activity";
  } else if (number == 4){
    return "Creativity";
  } else if (number == 5){
    return "Assurance";
  }
  return "";
}
    /* Utility Functions */
    drawSingleEmotionalNeedsName(name) {
      let value = name.split("/");
      if (typeof value != "undefined") {
        return value[0];
      }
      return name;
    }
}
export default new ProfileService();             
